import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actionsDocumentsList from './_redux/documentsActions';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

const DropdownDocuments = ({ select = undefined, selected, setSelected,disabled }) => {
    const [change, setChange] = useState(false);
    const toast = useRef(null);
    const dispatch = useDispatch();
    const { documentsList, listLoading, error } = useSelector(
        state => state.documents,
        shallowEqual
    );
    useEffect(() => {
        if (!documentsList && !error) {
            dispatch(actionsDocumentsList.fetchDocumentsList({}));
        };
    }, [documentsList, error, dispatch]);
    useEffect(() => {
        if (error) {
            toast.current.show({ severity: 'error', summary: 'Documents', detail: error });
        };
    }, [error]);
    return (
        <div>
            <Toast ref={toast} position="bottom-right" />
            {select && !change ?
                <div className="p-inputgroup">
                    <InputText value={select} disabled />
                    <Button disabled={disabled} icon="pi pi-pencil" style={{ color: 'white' }} className="p-button-warning" onClick={() => setChange(true)} type="button" />
                </div>
                :
                !documentsList && listLoading ?
                    <div className="p-d-flex p-jc-center">
                        <ProgressSpinner style={{ width: '30px', height: '30px' }} strokeWidth="8" animationDuration="3s" />
                    </div>
                    :
                    <div className="p-d-flex p-flex-row">
                        <Dropdown className={select ? "p-col-10" : "p-col-12"} optionLabel="ds_name" optionValue="id_type_of_document" value={selected}
                            options={documentsList}
                            onChange={(e) => setSelected(e.value)}
                            placeholder="Select a document"
                        />
                        {select &&
                            <Button icon="pi pi-times" className="p-button-danger"
                            
                                onClick={() => {
                                    setSelected(0);
                                    setChange(false);
                                }}
                                type="button"
                                tooltip="Cancel"
                            />
                        } 
                    </div>
            }
        </div>
    )
}

export default DropdownDocuments
